// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-ProductListing----ProductListing-module---container---2DS39","image":"src-components-ProductListing----ProductListing-module---image---QDJeq","info":"src-components-ProductListing----ProductListing-module---info---2-Tfu","title":"src-components-ProductListing----ProductListing-module---title---3wUhg","editItem":"src-components-ProductListing----ProductListing-module---editItem---2-0cd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductListing/ProductListing.module.scss
// module id = 480
// module chunks = 137591856104208 208175303390894